// DN° — un único archivo de JS vanilla para todas las páginas.
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantes();
  initCifras();
  initAcordeon();
});

function initReveal() {
  var els = document.querySelectorAll('.dn-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('dn-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('dn-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  els.forEach(function (el, i) {
    el.style.setProperty('--dn-i', i % 8);
    obs.observe(el);
  });

  // Red de seguridad: si por lo que sea el observer no dispara, no dejar el contenido invisible para siempre.
  setTimeout(function () {
    els.forEach(function (el) { el.classList.add('dn-visible'); });
    obs.disconnect();
  }, 2500);
}

function initGaleriaProducto() {
  var galerias = document.querySelectorAll('[data-dn-galeria]');
  galerias.forEach(function (galeria) {
    var principal = galeria.querySelector('[data-dn-galeria-principal]');
    var thumbs = galeria.querySelectorAll('[data-dn-galeria-thumb]');
    if (!principal || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (!src) return;
        principal.src = src;
        thumbs.forEach(function (t) { t.classList.remove('dn-activo'); });
        thumb.classList.add('dn-activo');
      });
    });
  });
}

function initVariantes() {
  var forms = document.querySelectorAll('[data-dn-producto-form]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-dn-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var selects = form.querySelectorAll('[data-dn-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-dn-precio]');
    var precioCompareEl = form.querySelector('[data-dn-precio-comparado]');
    var botonEl = form.querySelector('[data-dn-boton-comprar]');
    var textoAgotado = form.getAttribute('data-texto-agotado') || 'Agotado';
    var textoComprar = form.getAttribute('data-texto-comprar') || 'Añadir al carrito';

    if (!selects.length) return;

    function variantePorOpciones() {
      var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variantes.find(function (v) {
        return v.options.every(function (opt, idx) { return opt === valores[idx]; });
      });
    }

    function actualizar() {
      var variante = variantePorOpciones();
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = variante.price_formatted;
      if (precioCompareEl) {
        if (variante.compare_at_price_formatted) {
          precioCompareEl.textContent = variante.compare_at_price_formatted;
          precioCompareEl.style.display = '';
        } else {
          precioCompareEl.style.display = 'none';
        }
      }
      if (botonEl) {
        botonEl.disabled = !variante.available;
        botonEl.textContent = variante.available ? textoComprar : textoAgotado;
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    actualizar();
  });
}

function initCifras() {
  var cifras = document.querySelectorAll('[data-dn-cifra]');
  if (!cifras.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-dn-cifra')) || 0;
      var dur = 1200;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / dur, 1);
        el.textContent = Math.floor(progreso * fin);
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin;
      }
      requestAnimationFrame(paso);
      obs.unobserve(el);
    });
  }, { threshold: 0.4 });
  cifras.forEach(function (el) { obs.observe(el); });
}

function initAcordeon() {
  var items = document.querySelectorAll('[data-dn-acordeon-item]');
  items.forEach(function (item) {
    var boton = item.querySelector('[data-dn-acordeon-boton]');
    if (!boton) return;
    boton.addEventListener('click', function () {
      var abierto = item.classList.contains('dn-abierto');
      item.closest('[data-dn-acordeon]').querySelectorAll('[data-dn-acordeon-item]').forEach(function (i) {
        i.classList.remove('dn-abierto');
      });
      if (!abierto) item.classList.add('dn-abierto');
    });
  });
}
